// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__wioHi","card":"Dashboard_card__nXALC","chart":"Dashboard_chart__wdzMh","title":"Dashboard_title__P5GyA"};